import { render } from "./claimableCoupon.vue?vue&type=template&id=663b1fe8"
import script from "./claimableCoupon.vue?vue&type=script&lang=js"
export * from "./claimableCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__